export default __webpack_public_path__ + "static/15-39568ab21135051602997ff2c617a376.png";